<template >
   <v-app>
    <!-- <h2 class="font-weight-bold text-start" style="color: red;">EMBARGO SEHINGGA 2 NOVEMBER 2024</h2> -->
    <router-view style="background-color: #F4F1F8;" />
    <bottom-footer style="background-color: #F4F1F8;" ></bottom-footer>
   </v-app>
</template>

<script>
import TopHeader from "./views/Header/index.vue"
import BottomFooter from "./views/Footer/Index.vue"
export default {

components: {
    TopHeader,
    BottomFooter
  }
}

</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.background-container {
  height: 100vh; /* Full height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url('@/assets/svg/Hexagon2.svg'); /* Path to your image */
  background-size: cover; /* Cover the entire container */
  background-position: center; /* Center the image */
  color: white; /* Text color for contrast */
}
</style>

